$(function () {
  'use strict'
  
  // Alleen initialiseren voor tabellen die expliciet de datatable class hebben
  if ($('.datatable').length > 0) {
    $('.datatable').DataTable({
      "order": [
          [1, 'desc']
      ],
      "language" : {
          "zeroRecords": " "
      },
      "displayLength": 35,
    });
  }

  if ($('.helpdesk-datatable').length > 0) {
    $('.helpdesk-datatable').DataTable({
      "order": [
          [3, 'desc']
      ],
      "language" : {
          "zeroRecords": " "
      },
      "displayLength": 35,
    });
  }
});
